import { ChevronRight } from '@mui/icons-material';
import { styled, svgIconClasses } from '@mui/material';
import React, { type ComponentProps } from 'react';
import { Link } from 'react-router';

const StyledLink = styled(Link)(({ theme }) => ({
  color: theme.palette.primary.main,
  textDecoration: 'underline',
  '&:hover': {
    [`& .${svgIconClasses.root}`]: {
      marginLeft: '2px',
    },
  },
}));

export type ArrowLinkProps = ComponentProps<typeof StyledLink>;

export const ArrowLink: React.FC<ArrowLinkProps> = ({ children, ...props }) => {
  return (
    <StyledLink target="_blank" {...props}>
      {children}{' '}
      <ChevronRight
        sx={{
          verticalAlign: 'middle',
          mb: '1px',
          fontSize: '1.2em',
          transition: (theme) => theme.transitions.create('margin'),
        }}
        fontSize="inherit"
      />
    </StyledLink>
  );
};
